var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"control has-addons flatpickr",class:{ [`has-addons-${_vm.alignment}`]: _vm.alignment },attrs:{"data-wrap":"true","data-clickOpens":"false"}},[_c('input',{staticClass:"input",class:_vm.inputClass,attrs:{"type":"text","placeholder":_vm.placeholder,"data-input":""},domProps:{"value":_vm.value}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }